import React from 'react';
import { CameraIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function FounderNote() {
  return <section aria-labelledby="founder-heading" className="bg-navy pb-24 pt-12 text-paper md:pb-32" data-id="element-63" data-mp="2m75dp050xoc8">
      <Reveal className="mx-auto max-w-2xl px-6" data-id="element-64" data-mp="287vwpy8zuq77">
        <article className="relative rounded-sm border border-paper/10 bg-[#102A4C] py-12 pl-12 pr-8 shadow-[0_24px_48px_-24px_rgba(0,0,0,0.7)] md:py-16 md:pl-20 md:pr-14" data-id="element-65" data-mp="2d7s0pxhoyhmr">
          {/* Letter-paper margin line */}
          <span aria-hidden="true" className="absolute bottom-10 left-6 top-10 w-px bg-honor/60 md:left-12" data-id="element-66" data-mp="23a47jbzqhi6p" />

          <h2 id="founder-heading" className="text-sm font-semibold tracking-[0.2em] text-gold" data-id="element-67" data-mp="1piz3zyt8w5r3">
            A NOTE FROM OUR FOUNDER
          </h2>

          <p className="mt-8 font-serif text-2xl italic leading-relaxed text-paper" data-id="element-68" data-mp="1uf6c9y945tc7">
            [FOUNDER NOTE — CLIENT TO PROVIDE, 80 TO 120 WORDS]
          </p>

          <div aria-hidden="true" className="mt-12 h-px w-40 bg-gold/60" data-id="element-69" data-mp="1ki1ojtzmdpta" />
          <p className="mt-3 font-hand text-3xl font-semibold leading-snug text-paper" data-id="element-70" data-mp="16ns7rr06e5cu">
            [FOUNDER NAME AND SERVICE BRANCH]
          </p>

          <figure className="mt-10 flex items-center gap-5" data-id="element-71" data-mp="11oyvu30jemes">
            <div role="img" aria-label="Founder photo placeholder" className="flex h-24 w-24 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-paper/40 bg-navy-deep" data-id="element-72" data-mp="1fp9jkx6jvkvq">
              <CameraIcon aria-hidden="true" className="h-7 w-7 text-gold" strokeWidth={1.5} data-id="element-73" data-mp="nvfwgerjntqk" />
            </div>
            <figcaption className="text-lg leading-snug text-paper/85" data-id="element-74" data-mp="wq42w88uvhgy">Founder photo, 600 × 600 px or larger.</figcaption>
          </figure>
        </article>
      </Reveal>
    </section>;
}